import MonthlyReportPage from './MonthlyReportPage';

export default MonthlyReportPage;
